import { render, staticRenderFns } from "./page-heading.vue?vue&type=template&id=f43377f4&scoped=true"
import script from "./page-heading.vue?vue&type=script&lang=ts"
export * from "./page-heading.vue?vue&type=script&lang=ts"
import style0 from "./page-heading.vue?vue&type=style&index=0&id=f43377f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f43377f4",
  null
  
)

export default component.exports